import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { environment } from "src/environments/environment";

@Injectable({
  providedIn: "root",
})
export class CategorieService {
  constructor(private httpClient: HttpClient) {}

  getData() {
    return this.httpClient.get(environment.Localurl + "categorie");
  }

  insertData(data) {
    return this.httpClient.post(environment.Localurl + "categorie", data);
  }

  deleteData(id) {
    return this.httpClient.delete(environment.Localurl + "categorie/" + id);
  }

  getOneData(id) {
    return this.httpClient.get(environment.Localurl + "categorie/" + id);
  }

  updateData(id, data) {
    return this.httpClient.put(environment.Localurl + "categorie/" + id, data);
  }
}
